import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { userKeys } from "./query-keys";

export type UpdateUserValues = components["schemas"]["UpdateUserRequest"];

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, body }: { id: string; body: UpdateUserValues }) => {
      const { data, error } = await apiClient.PUT("/v1/admin/users/{id}", {
        params: { path: { id } },
        body,
      });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: userKeys.all });
    },
  });
}
